var map = {
	"./bg-wait-goods.png": "7e61",
	"./bg-wait-openshop.png": "654f",
	"./bg-wait-vertify.png": "cbc3",
	"./bg-wait.png": "78d1",
	"./bj1.png": "c731",
	"./bj2.png": "f931",
	"./bj3.png": "1a8c",
	"./bj4.png": "b74c",
	"./icon-data-split.png": "9229",
	"./icon-data.png": "b79e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2802";